<div class="dmv-search-results inner-home">
  <div class="container">
    <div class="row no-margin">
      <!--heading section starts here-->
      <div class="col-6 col-sm-2 mt-4 ">
        <a>
          <button class="btn btn-primary btn-back top-back-button" (click)="goBack()"><i
              class="fa fa-chevron-left text-left"></i> Back</button>
        </a>
      </div>

      <div class="col-12 col-sm-8 mt-4">
        <div id="searchResu" class="smhd">{{title}}</div>
        <p id="addthereco">{{subtitle}}</p>
      </div>


      <div class="col-6 col-sm-2 icon-cart mt-4">
        <dmv-shoping-cart
          [registrationsInCart]="dmvStoreService?.registrationsInCart?.dmvRegistrations"></dmv-shoping-cart>
      </div>

      <!--heading section ends here-->

      <div class="alert alert-danger" role="alert" *ngIf="errorMessage">
        {{errorMessage}}
      </div>

      <div class="col-12 col-sm-6">
        <div class="col-12 rectangle-pickup" id="rectangle"
          *ngFor="let location of locations; let i = index">
          <div class="row no-margin mt-1 mb-4 pt-3 pb-3 pickup-main">
            <div class="number-circle">
              {{i+1}}
            </div>
            <div class="width90">
              <div id="sRosalindA" class="boldText">{{location?.name}}</div>
              <div id="address"> {{location?.address?.line1}} {{location?.address?.line2}}
                <br />{{location?.address?.city}}, {{location?.address?.stateCode}} {{location?.address?.postalCode}}
              </div>
              <div id="phone-number" *ngIf="location?.phone">{{location?.phone}}</div>
              <div id="monTuesThu" *ngIf="location?.descriptorText1"
                [innerHTML]="location?.descriptorText1 | asterikToHtmlTags: '*br*':'&lt;br&gt;'"></div>
            </div>

            <div *ngIf="!supportKioskPickup" class="icon-success" [ngClass]="(isInCart(location)) ? ' list-btn-added' : ' list-btn-add'">
              <button (click)="removeInCart(location, i)" class="list-btn added"><i class="fa fa-check"></i></button>
              <button (click)="addInCart(location, i)" class="list-btn add"
                [style.background-color]="(dmvStoreService.agencyConfigData$ | async)?.agencyDmvConfig?.secondaryColor">
                <div></div>
                <div></div>
              </button>

            </div>

          </div>
        </div>

      </div>
      <div class="col-12 col-sm-6 mt-3 mb-4">
        <div id="map" style="width:100%; height:500px"></div>
      </div>

      <div class="col-12 col-sm-12">
        <div>
          <form *ngIf="!supportKioskPickup" autocomplete="off" class="text-left mb-5" [formGroup]="authorizedPersonForm">
            <div class="checkbox-container">
              <label>I authorize the following person to pick up the renewal documents
                <input type="checkbox" (change)="changepersonNameCheck($event)" formControlName="personNameCheck"
                  [ngClass]="{ 'is-invalid': submitted && !f.personNameCheck.value }">
                <span class="checkmark checkmarkIns"
                  [ngStyle]="f.personNameCheck.value?{'background-color':(dmvStoreService.agencyConfigData$ | async)?.agencyDmvConfig?.primaryColor} : {'background-color': 'transparent'}"
                  [style.border-color]="(submitted && !f.personNameCheck.value)? '#dc3545':(dmvStoreService.agencyConfigData$ | async)?.agencyDmvConfig?.primaryColor"></span>
              </label> <br>
              <label class="graytext" *ngIf="f.personNameCheck.value">Photo ID must be provided for verification</label>
            </div>
            <div *ngIf="f.personNameCheck.value">
              <input type="text" formControlName="name" class="form-control" maxlength="40" id="name"
                [ngClass]="{ 'is-invalid': submitted && f.name.errors }" placeholder="Name">
              <div *ngIf="submitted && f.name.errors" class="invalid-feedback">
                <div *ngIf="f.name.errors?.required">Please enter name</div>
                <div *ngIf="f.name.errors?.pattern">Invalid symbols found. Please retry.</div>
              </div>
            </div>
          </form>


          <form *ngIf="supportKioskPickup" autocomplete="off" class="text-left mb-5" [formGroup]="authorizedPersonForm">
            <div class="row">
              <label class="col-12 col-sm-12">When the documents are ready, we’ll send you a pickup email.</label>
              </div>
             
           
        
          <div class="row">
            <div class="col-12 col-sm-5  mb-4">
              <label class="lblPin">Email Address</label>
              <input type="text"   formControlName="email" class="form-control" id="phone"
        
                [ngClass]="{ 'is-invalid': submitted && f.email.errors }">
              <div *ngIf="submitted && f.email.errors" class="invalid-feedback">
                <div *ngIf="f.email.errors?.required">Please enter email address.</div>
                <div *ngIf="f.email.errors?.pattern">Email address is invalid.</div>
              </div>
            </div>
            <div class="col-12 col-sm-5  mb-4">
              <label class="lblPin">Confirm Email Address</label>
              <input type="text" formControlName="confirmEmail" class="form-control" id="confirmEmail"
            
              [ngClass]="{ 'is-invalid': submitted && f.confirmEmail.errors }" >
            <div *ngIf="submitted && f.confirmEmail.errors" class="invalid-feedback">
              <div *ngIf="f.confirmEmail.errors?.required">Please enter email address.</div>
              <div *ngIf="f.confirmEmail.errors?.pattern">Email address is invalid.</div>
              <div *ngIf="f.confirmEmail?.errors?.mustMatch">The two email addresses are not the same; please retry.</div>
            </div>
            </div>
          </div>
          </form>
        </div>

      </div>
      

    </div>
    <div class="m-auto text-center">
      <a>
        <button class="btn btn-primary btn-back" (click)="goBack()"><i class="fa fa-chevron-left text-left"></i>
          Back</button>
      </a>
      <a>
        <button class="btn btn-primary  btn-continue m-auto" (click)="continue()"
        [attr.disabled]="((!pickupLocation && !supportKioskPickup) || (supportKioskPickup && 
          !( f?.email?.value && f.confirmEmail.value) 
          )) ?'disabled':null" [ngClass]="{'disabled': (!pickupLocation && !supportKioskPickup) || ( (supportKioskPickup && 
          !( f?.email?.value && f.confirmEmail.value) 
          ))  }">Continue
          <i class="fa fa-chevron-right text-right"></i>
        </button>
      </a>
    </div>
  </div>
</div>

<dmv-pickup-in-person-model *ngIf="authorizedPersonPopup" (closeAuthorizedPerson)="closeAuthorizedPerson()"
  (updateAuthorizedPerson)="updateAuthorizedPerson($event)"></dmv-pickup-in-person-model>